var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"linkedin"),React.createElement("path",{"d":"M106.09,20.5a1.41,1.41,0,0,1,1.41,1.41h0V106.1a1.41,1.41,0,0,1-1.41,1.41H21.91a1.41,1.41,0,0,1-1.41-1.41h0V21.91a1.41,1.41,0,0,1,1.41-1.41H106.1m0-6.5H21.91A7.91,7.91,0,0,0,14,21.91h0V106.1a7.92,7.92,0,0,0,7.91,7.9H106.1a7.91,7.91,0,0,0,7.91-7.91h0V21.91A7.91,7.91,0,0,0,106.1,14h0Z","key":1}),React.createElement("rect",{"x":"37.27","y":"50.4","width":"11.73","height":"41.73","key":2}),React.createElement("path",{"d":"M77.23,50.4c-10,0-10.23,5.81-10.23,6.21V50.4H55V92.13H67V68.31c0-1.86.55-5.86,6.23-5.86s5.63,5.73,5.63,5.73v24H90.73v-26C90.73,53.85,84,50.4,77.23,50.4Z","key":3}),React.createElement("circle",{"cx":"43.13","cy":"41.73","r":"5.86","key":4})]);
}

Linkedin.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 128 128"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
